/* global window */
import { WebStorageStateStore } from 'oidc-client';
import { createUserManager } from 'redux-oidc';

const userManagerConfig = {
  client_id: window.env.okta_client_id,
  redirect_uri: window.env.redirect_uri,
  authority: window.env.okta_authority,
  response_type: 'code',
  scope: 'profile openid',
  userStore: new WebStorageStateStore({ store: localStorage }),
  metadata: {
    issuer: window.env.issuer,
    authorization_endpoint: window.env.authorization_endpoint,
    token_endpoint: window.env.token_endpoint,
    userinfo_endpoint : window.env.userinfo_endpoint,
    jwks_uri: window.env.jwks_uri,
    end_session_endpoint: window.env.end_session_endpoint
  }
};

const userManager = createUserManager(userManagerConfig);

export default userManager;



// WEBPACK FOOTER //
// ./src/containers/login/userManager.jsx